import { createTypes, createAction } from "lib/action";

const LOAD_DAILY = createTypes("daily", "load");
const LOAD_VEHICLE_DAILY = createTypes(
  "vehicle_daily",
  "load"
);
const LOAD_VEHICLE_TYPE_DAILY = createTypes("vehicletype_daily", "load");

const loadDaily = {
  request: (data, loading) =>
    createAction(LOAD_DAILY.REQUEST, { data, loading }),
  success: data => createAction(LOAD_DAILY.SUCCESS, { data }),
  failure: () => createAction(LOAD_DAILY.FAILURE)
};

const loadVehicle = {
  request: (vehicletypeID, loading_vehicle) =>
    createAction(LOAD_VEHICLE_DAILY.REQUEST, {
      vehicletypeID,
      loading_vehicle
    }),
  success: data =>
    createAction(LOAD_VEHICLE_DAILY.SUCCESS, { data }),
  failure: () => createAction(LOAD_VEHICLE_DAILY.FAILURE)
};

const loadVehicleType = {
  request: () => createAction(LOAD_VEHICLE_TYPE_DAILY.REQUEST, {}),
  success: data => createAction(LOAD_VEHICLE_TYPE_DAILY.SUCCESS, { data }),
  failure: () => createAction(LOAD_VEHICLE_TYPE_DAILY.FAILURE)
};

export {
  loadDaily,
  LOAD_DAILY,
  loadVehicle,
  LOAD_VEHICLE_DAILY,
  loadVehicleType,
  LOAD_VEHICLE_TYPE_DAILY
};
